import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { DatepickerComponent } from './datepicker.component';

@NgModule({
    declarations: [DatepickerComponent],
  imports: [
      CommonModule,
      FormsModule,
      MyDatePickerModule
    ],
    exports: [DatepickerComponent]
})
export class DatepickerModule { }
